import { createContext } from "react";
const ServiceCounterContext = createContext({});
export default ServiceCounterContext;
